/**
 * Replaces Fiuu payment URL placeholders with the configured merchant ID.
 * Supports: {MerchantID}, {merchantID}, /merchantID
 */
export const resolveFiuuPaymentUrl = (
	urlTemplate: string,
	merchantID: string,
): string => {
	if (!urlTemplate?.trim()) {
		return '';
	}
	if (!merchantID?.trim()) {
		return urlTemplate.trim();
	}

	const encodedMerchantID = encodeURIComponent(merchantID.trim());

	return urlTemplate
		.trim()
		.replace(/\{MerchantID\}/g, encodedMerchantID)
		.replace(/\{merchantID\}/g, encodedMerchantID)
		.replace(/\/merchantID(?=\/|$|\?)/gi, `/${encodedMerchantID}`);
};
